if (!customElements.get("notify-form")) {
  customElements.define(
    "notify-form",
    class NotifyForm extends HTMLElement {
      constructor() {
        super();
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        this.alertMessageWrapper = this.querySelector(
          '[data-asset="alert-message"]'
        );

        if (!window.location.pathname.includes("/collections/")) {
          window.Shopify?.analytics?.publish?.("availability_status", {
            variant_id: this.dataset.variantId || null,
            days_until_available: 99,
          });
        }
      }

      connectedCallback() {
        this.querySelector(
          '[data-asset="product-notify-form"]'
        )?.addEventListener("submit", this.onFormSubmit);
      }

      onFormSubmit(event) {
        event.preventDefault();
        this.productId = this.dataset.productId;
        this.variantId = this.dataset.variantId;
        const submitButton = event.target.querySelector(
          'button[type="submit"]'
        );
        submitButton?.setAttribute("disabled", true);
        this.classList.add("loading");

        const formData = new FormData(event.target);
        const data = Object.fromEntries(formData.entries());
        try {
          if (typeof window.BIS === "object") {
            if (Shopify && Shopify.analytics) {
              window.Shopify?.analytics?.publish?.("email_when_available", {
                email: data?.user_email ?? "",
                product_id: this.productId ?? 0,
                variant_id: this.variantId ?? 0,
                product_title: data?.product_title ?? "",
                accepts_marketing: data?.accepts_marketing === "on",
              });
            }

            window.BIS.create(
              data?.user_email,
              this.variantId,
              this.productId,
              {
                accepts_marketing: data?.accepts_marketing === "on",
              }
            ).then((response) => {
              submitButton?.removeAttribute("disabled");
              this.classList.remove("loading");
              event.target.reset();
              if (response.status === "OK") {
                this.setMessage(response.message, "success");
              } else {
                this.setMessage(response?.errors?.base[0], "error");
              }
            });
          } else {
            this.setMessage("BIS not initialized!", "error");
          }
        } catch (error) {
          this.setMessage(error.getMessage(), "error");
        }
      }

      setMessage(message, type) {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }

        if ((message != "") & (type != "")) {
          this.alertMessageWrapper.querySelector(
            ".notify-form__message-text"
          ).textContent = message;
          this.alertMessageWrapper.classList.add(type);
          this.alertMessageWrapper.classList.add("active");
        }
        const isPopup = this.dataset.popup;
        if (isPopup) {
          document.querySelector(".field__accepts_marketing").style.display =
            "none";
          this.timeout = setTimeout(() => {
            this.alertMessageWrapper.querySelector(
              ".notify-form__message-text"
            ).textContent = "";
            document.querySelector(".field__accepts_marketing").style.display =
              "flex";
            this.alertMessageWrapper.classList.remove(type);
            this.alertMessageWrapper.classList.remove("active");
          }, 3000);
        } else {
          this.timeoutId = setTimeout(() => {
            this.alertMessageWrapper.querySelector(
              ".notify-form__message-text"
            ).textContent = "";
            this.alertMessageWrapper.classList.remove(type);
            this.alertMessageWrapper.classList.remove("active");
          }, 1500);
        }
      }
    }
  );
}

window.openNotifyModal = function (productId, variantId) {
  const modal = document.querySelector('.modal.notify-form');
  const notifyForm = modal?.querySelector('notify-form') || document.querySelector('notify-form');

  if (!notifyForm) {
    console.error('NotifyForm element not found!');
    return;
  }

  const resolvedProductId = productId || notifyForm.getAttribute('data-product-id') || null;
  const resolvedVariantId = variantId || notifyForm.getAttribute('data-variant-id') || null;

  if (resolvedProductId) {
    notifyForm.setAttribute('data-product-id', resolvedProductId);
    if (Object.prototype.hasOwnProperty.call(notifyForm, 'productId')) {
      notifyForm.productId = resolvedProductId;
    }
  }

  if (resolvedVariantId) {
    notifyForm.setAttribute('data-variant-id', resolvedVariantId);
    if (Object.prototype.hasOwnProperty.call(notifyForm, 'variantId')) {
      notifyForm.variantId = resolvedVariantId;
    }
  }

  if (modal) {
    modal.setAttribute('aria-hidden', 'false');
  } else {
    console.error('Notify modal element (.modal.notify-form) not found!');
  }
};

(function () {
  function resolveProductId(button) {
    const fromDataset = button?.dataset.productId || button?.getAttribute('data-product-id');
    if (fromDataset) return fromDataset;

    const blockScopedId = button?.closest('[data-block-id="product-form"]')?.dataset.productId;
    if (blockScopedId) return blockScopedId;

    const analyticsProductId = window?.ShopifyAnalytics?.meta?.product?.id;
    if (analyticsProductId) return analyticsProductId;

    return null;
  }

  function resolveVariantId(button) {
    const fromDataset = button?.dataset.variantId || button?.getAttribute('data-variant-id');
    if (fromDataset) return fromDataset;

    const scope = button?.closest('[data-block-id="product-form"]') || document;
    const variantInput = scope.querySelector('.product-variant-id, [name="id"]');
    if (variantInput?.value) return variantInput.value;

    const selectedVariantScript = scope.querySelector('[data-selected-variant]');
    if (selectedVariantScript?.textContent) {
      try {
        const parsed = JSON.parse(selectedVariantScript.textContent);
        if (parsed?.id) return parsed.id;
      } catch (error) {
        console.warn('Failed to parse selected variant payload', error);
      }
    }

    return null;
  }

  function handleNotifyButtonClick(event) {
    const button = event.target.closest('[data-action="open-notify-modal"]');
    if (!button) return;

    event.preventDefault();

    const productId = resolveProductId(button);
    const variantId = resolveVariantId(button);

    window.openNotifyModal(productId, variantId);
  }

  document.addEventListener('click', handleNotifyButtonClick, {
    capture: false,
  });
})();

